// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-defaults-modal .dialog-title {
  padding: 8px 20px 12px;
  border-bottom: 1px solid #e0e0e0;
}
.system-defaults-modal .dialog-title[mat-dialog-title] {
  margin: 0;
  padding-top: 8px;
}
.system-defaults-modal .dialog-title h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.system-defaults-modal .dialog-content {
  padding: 0;
  overflow-x: hidden;
}
.system-defaults-modal ::ng-deep .mat-mdc-dialog-title::before {
  display: none;
}
.system-defaults-modal .loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 16px;
}
.system-defaults-modal .loading-spinner p {
  margin: 0;
  color: #666;
}
.system-defaults-modal .tabs {
  width: 100%;
}
.system-defaults-modal .tabs ::ng-deep .mat-mdc-tab-body-wrapper,
.system-defaults-modal .tabs ::ng-deep .mat-mdc-tab-body-content {
  overflow-x: hidden !important;
}
.system-defaults-modal .tab-content {
  padding: 12px 20px;
}
.system-defaults-modal .tab-description {
  margin: 0 0 10px 0;
  color: #666;
  font-size: 13px;
}
.system-defaults-modal .test-list {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 12px;
}
.system-defaults-modal .test-list mat-list-item {
  height: 36px !important;
  padding: 0 12px;
}
.system-defaults-modal .fluid-type-section {
  padding-bottom: 8px;
  padding-left: 4px;
}
.system-defaults-modal .constants-form {
  margin-bottom: 8px;
}
.system-defaults-modal .form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.system-defaults-modal .field-col {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 140px;
}
.system-defaults-modal .field-col .form-control {
  width: 100%;
}
.system-defaults-modal .field-label {
  font-size: 12px;
  margin-bottom: 0;
}
.system-defaults-modal .button-group {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  margin-top: 8px;
}
.system-defaults-modal .button-group button {
  display: flex;
  align-items: center;
  gap: 8px;
}
.system-defaults-modal .dialog-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0e0;
}
.system-defaults-modal .footer-message {
  flex: 1;
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 4px;
}
.system-defaults-modal .footer-message.error-message {
  background-color: #ffebee;
  color: #c62828;
  border-left: 3px solid #c62828;
}
.system-defaults-modal .footer-message.success-message {
  background-color: #e8f5e9;
  color: #2e7d32;
  border-left: 3px solid #2e7d32;
}
.system-defaults-modal .error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 10px;
  border-left: 4px solid #c62828;
  font-size: 13px;
}
.system-defaults-modal .success-message {
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 10px;
  border-left: 4px solid #2e7d32;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/system-defaults-modal/system-defaults-modal.component.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,gCAAA;AAAJ;AAGI;EACE,SAAA;EACA,gBAAA;AADN;AAII;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAFN;AAME;EACE,UAAA;EACA,kBAAA;AAJJ;AAQE;EACE,aAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AAPJ;AASI;EACE,SAAA;EACA,WAAA;AAPN;AAWE;EACE,WAAA;AATJ;AAWI;;EAEE,6BAAA;AATN;AAaE;EACE,kBAAA;AAXJ;AAcE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AAZJ;AAeE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AAbJ;AAeI;EACE,uBAAA;EACA,eAAA;AAbN;AAiBE;EACE,mBAAA;EACA,iBAAA;AAfJ;AAkBE;EACE,kBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAlBJ;AAoBI;EACE,WAAA;AAlBN;AAsBE;EACE,eAAA;EACA,gBAAA;AApBJ;AAuBE;EACE,aAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AArBJ;AAuBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AArBN;AAyBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;AAvBJ;AA0BE;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAxBJ;AA0BI;EACE,yBAAA;EACA,cAAA;EACA,8BAAA;AAxBN;AA2BI;EACE,yBAAA;EACA,cAAA;EACA,8BAAA;AAzBN;AA6BE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AA3BJ;AA8BE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AA5BJ","sourcesContent":[".system-defaults-modal {\n  .dialog-title {\n    padding: 8px 20px 12px;\n    border-bottom: 1px solid #e0e0e0;\n\n    // Override Material's default top margin/padding on mat-dialog-title\n    &[mat-dialog-title] {\n      margin: 0;\n      padding-top: 8px;\n    }\n\n    h2 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 500;\n    }\n  }\n\n  .dialog-content {\n    padding: 0;\n    overflow-x: hidden;\n  }\n\n  // Remove Material's default extra top padding above the title\n  ::ng-deep .mat-mdc-dialog-title::before {\n    display: none;\n  }\n\n  .loading-spinner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 40px;\n    gap: 16px;\n\n    p {\n      margin: 0;\n      color: #666;\n    }\n  }\n\n  .tabs {\n    width: 100%;\n\n    ::ng-deep .mat-mdc-tab-body-wrapper,\n    ::ng-deep .mat-mdc-tab-body-content {\n      overflow-x: hidden !important;\n    }\n  }\n\n  .tab-content {\n    padding: 12px 20px;\n  }\n\n  .tab-description {\n    margin: 0 0 10px 0;\n    color: #666;\n    font-size: 13px;\n  }\n\n  .test-list {\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    margin-bottom: 12px;\n\n    mat-list-item {\n      height: 36px !important;\n      padding: 0 12px;\n    }\n  }\n\n  .fluid-type-section {\n    padding-bottom: 8px;\n    padding-left: 4px;\n  }\n\n  .constants-form {\n    margin-bottom: 8px;\n  }\n\n  .form-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 12px;\n  }\n\n  .field-col {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 140px;\n\n    .form-control {\n      width: 100%;\n    }\n  }\n\n  .field-label {\n    font-size: 12px;\n    margin-bottom: 0;\n  }\n\n  .button-group {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-start;\n    margin-top: 8px;\n\n    button {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n  }\n\n  .dialog-footer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 20px;\n    border-top: 1px solid #e0e0e0;\n  }\n\n  .footer-message {\n    flex: 1;\n    font-size: 13px;\n    padding: 4px 8px;\n    border-radius: 4px;\n\n    &.error-message {\n      background-color: #ffebee;\n      color: #c62828;\n      border-left: 3px solid #c62828;\n    }\n\n    &.success-message {\n      background-color: #e8f5e9;\n      color: #2e7d32;\n      border-left: 3px solid #2e7d32;\n    }\n  }\n\n  .error-message {\n    background-color: #ffebee;\n    color: #c62828;\n    padding: 8px 12px;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    border-left: 4px solid #c62828;\n    font-size: 13px;\n  }\n\n  .success-message {\n    background-color: #e8f5e9;\n    color: #2e7d32;\n    padding: 8px 12px;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    border-left: 4px solid #2e7d32;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
